import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PreSimulationDetails } from '../models/pre-simulation-details';
import { SimulationTracker } from '../interfaces/simulation-tracker';
import { SimulationDetails } from '../interfaces/simulation-details';
import { SimulationConfiguration } from '../interfaces/simulation-configuration';

@Injectable({
  providedIn: 'root',
})
export class ApiTerrainService {
  apiBase: string = '/api/terrain';

  constructor(private http: HttpClient) {}

  public getPreSimulationDetails(
    simulationId: string
  ): Observable<PreSimulationDetails> {
    const endpoint: string = `${this.apiBase}/${simulationId}/pre-simulation-details`;
    return this.http.get<PreSimulationDetails>(endpoint);
  }

  public createSimulationBatch(
    simulationId: string,
    configuration: SimulationConfiguration,
  ): Observable<SimulationTracker> {
    const endpoint: string = `${this.apiBase}/simulation/${simulationId}/batch`;
    return this.http.post<SimulationTracker>(endpoint, configuration);
  }

  public queueSimulationRunGroup(
    simulationId: string,
    configuration: SimulationConfiguration
  ): Observable<SimulationTracker[]> {
    const endpoint: string = `${this.apiBase}/simulation/${simulationId}/scenario-batch`;
    return this.http.post<{ $id: number; $values: SimulationTracker[] }>(endpoint, configuration)
      .pipe(map((r) => r.$values));
  }

  public killLoop(simulationId: string) {
    const endpoint: string = `${this.apiBase}/${simulationId}/simulation/loop`;
    return this.http.delete(endpoint);
  }

  public reset(simulationId: string) {
    const endpoint: string = `${this.apiBase}/${simulationId}/simulation`;
    return this.http.delete(endpoint);
  }

  public getSimulationDetails(
    simulationId: string
  ): Observable<SimulationDetails> {
    const endpoint: string = `${this.apiBase}/${simulationId}/simulation/details`;
    return this.http.get<SimulationDetails>(endpoint);
  }
}
